import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '@/router'

Vue.use(VueGtag, {
  config: {id: "G-VL44QJ35CL"}
}, router)